import Styled from 'styled-components'

export const Text = Styled.div`
color: ${props => props.theme.primary};;
font-weight: 500;
font-size: 16px;
line-height: 4rem;
display: flex;
justify-content: space-between;
align-items: center;
border-bottom: 1px solid rgba(5, 9, 34, 0.16);

p {
    margin: 0;
}

p:nth-child(1) {
    //width: 110px;
    //min-width: 110px;
    width: 35%;
}

p:nth-child(2) {
    color: ${props => props.theme.primary};;
    font-weight: bold;
    font-size: 16px;
    line-height: 20px;
    text-align: right;
    text-transform: capitalize;
    width: 65%;
     
    span:after {
        content: ' | ';
    }
    
    span:last-child:after {
        content: '';
    }
}
`